// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"40f50972","977":"35d7bdb8"}[chunkId] + ".chunk.js";
};